import axios from "axios";

export interface ISavePersonalDetailsOnBasicAppFormEvent {
  transaction: {
    id: string;
  };
  formData: {
    title: string;
    salutation: string;
    firstName: string;
    lastName: string;
    email: string;
    mobilePhoneCountryCode: string;
    mobilePhoneNumber: string;
    nationality: string;
    birthDate: string;
    countryCode: string;
  };
}

export interface ISavePersonalDetailsOnFullAppFormEvent {
  transaction: {
    id: string;
  };
  formData: {
    title: string;
    salutation: string;
    firstName: string;
    lastName: string;
    placeOfBirth: string;
    birthDate: string;
    nationality: string;
    maidenName: string;
  };
}

export const savePersonalDetails = async (
  transactionId: string,
  formValues: {
    title: string;
    salutation: string;
    firstName: string;
    lastName: string;
    email: string;
    mobilePhoneCountryCode: string;
    mobilePhoneNumber: string;
    nationality: string;
    birthDate: string;
    countryCode: string;
    maidenName: string;
  }
) => {
  const body: ISavePersonalDetailsOnBasicAppFormEvent = {
    transaction: {
      id: transactionId,
    },
    formData: {
      title: formValues.title,
      salutation: formValues.salutation,
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      email: formValues.email,
      mobilePhoneCountryCode: formValues.mobilePhoneCountryCode,
      mobilePhoneNumber: formValues.mobilePhoneNumber,
      nationality: formValues.nationality,
      birthDate: formValues.birthDate,
      countryCode: formValues.countryCode,
    },
  };

  return axios.post(process.env.REACT_APP_SAVE_PERSONAL_DETAILS_URL, body);
};

export const savePersonalDetailsFullAppForm = async (
  transactionId: string,
  formValues: {
    title: string;
    salutation: string;
    firstName: string;
    lastName: string;
    placeOfBirth: string;
    birthDate: string;
    nationality: string;
    maidenName: string;
  }
) => {
  const body: ISavePersonalDetailsOnFullAppFormEvent = {
    transaction: {
      id: transactionId,
    },
    formData: {
      title: formValues.title,
      salutation: formValues.salutation,
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      placeOfBirth: formValues.placeOfBirth,
      birthDate: formValues.birthDate,
      nationality: formValues.nationality,
      maidenName: formValues.maidenName,
    },
  };

  return axios.post(
    process.env.REACT_APP_SAVE_PERSONAL_DETAILS_FULL_APP_FORM_URL,
    body
  );
};
